import React from 'react';
import merge from 'classnames';

import { formatPriceWithCurrency } from '@/utils/format-price';

import { OrderBlockWrapper } from '../OrderBlockWrapper';

import styles from './OrderBlock.module.scss';

export type Props = {
  title: React.ReactNode | string;
  value?: number;
  valueNotes?: string;
  children?: React.ReactNode;
  color?: string;
  smallHeader?: boolean;
  divider?: boolean;
  hideValue?: boolean;
  classes?: {
    blockWrapper?: string;
    orderBlock?: string;
    title?: string;
    value?: string;
  };
};

export const OrderBlock = (props: Props) => {
  const {
    title,
    value,
    valueNotes,
    smallHeader,
    divider,
    hideValue = false,
    classes,
    children,
  } = props;

  return (
    <OrderBlockWrapper className={classes?.blockWrapper} color={props.color}>
      <div className={merge(styles.order_block, classes?.orderBlock)}>
        <span
          className={merge(
            styles.order_block_title,
            {
              [styles.order_block_small_header]: smallHeader,
            },
            classes?.title,
          )}
        >
          {title}
        </span>
        {!hideValue && (
          <div className={styles.order_block_value_wrapper}>
            <span
              className={merge(styles.order_block_value, classes?.value, {
                [styles.order_block_small_header]: smallHeader,
              })}
            >
              {formatPriceWithCurrency(value)}
            </span>
            {valueNotes && <span className={styles.order_block_label}>{valueNotes}</span>}
          </div>
        )}
      </div>
      {divider && <hr className={styles.panel_divider} />}
      {children}
    </OrderBlockWrapper>
  );
};
